import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  CreateIntegrationRequestData,
  GetHookDeliveriesParams,
  GetIntegrationsParams,
  HookDelivery,
  HookEventType,
  Integration,
  UpdateIntegrationRequestData,
} from '../types';

export function useIntegrationsApi() {
  return useMemo(
    () => ({
      getIntegrations: (params: GetIntegrationsParams) => {
        return apiClient.get<{ items: Integration[]; count: number }>(`/hooks`, { params });
      },

      getIntegration: (integrationId: string, companyId: string) => {
        return apiClient.get<Integration>(`/hooks/${integrationId}`, { params: { companyId } });
      },

      getHookDeliveries: (integrationId: string, params: GetHookDeliveriesParams) => {
        return apiClient.get<{ items: HookDelivery[]; count: number }>(`/hooks/${integrationId}/deliveries`, {
          params,
        });
      },

      createIntegration: (data: CreateIntegrationRequestData, companyId: string) => {
        return apiClient.post<Integration[]>(`/hooks`, data, { params: { companyId } });
      },

      updateIntegration: (
        data: UpdateIntegrationRequestData,
        integrationId: string,
        companyId: string,
      ) => {
        return apiClient.put<Integration>(`/hooks/${integrationId}`, data, {
          params: { companyId },
        });
      },

      pauseIntegration: (integrationId: string, companyId: string) => {
        return apiClient.post<Integration>(`/hooks/${integrationId}/pause`, undefined, {
          params: { companyId },
        });
      },

      activateIntegration: (integrationId: string, companyId: string) => {
        return apiClient.post<Integration>(`/hooks/${integrationId}/activate`, undefined, {
          params: { companyId },
        });
      },

      deleteIntegration: (integrationId: string, companyId: string) => {
        return apiClient.delete<void>(`/hooks/${integrationId}`, { params: { companyId } });
      },

      getHookEventTypes: () => {
        return apiClient.get<HookEventType[]>(`/hooks/event-types`);
      },
    }),
    [],
  );
}
